export default {
    name: 'RArea',
    props: {
        value: {
            type: Array,
            default() {
                return [];
            }
        },
        defaultValue: {
            type: Array,
            default() {
                return [370000, 370100, '', this.isjudge];
            }
        }
    },
    data() {
        return {
            area1: [],
            area2: [],
            area3: [],
            selectlist1: [],
            selectArea1: '',//370000
            selectArea2: '',//370100
            selectArea3: '',//370112
            isjudge: false,
            isLoading1: false,
            isLoading2: false,
            isLoading3: false,
            loading: null,
        };
    },
    methods: {
        // 用于初始化一些数据
        init() {
            this.upArea1();
            // defaultValue

        },
        // 用于更新一些数据
        update() {

            this.loading.close();
        },
        close() {
            if (this.loading) {
                this.loading.close();
            }
        },
        showLoading() {
            this.close();
            this.loading = this.$loading({
                lock: true,
                text: '加载地区中……',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        },
        // 获取省份
        async upArea1() {
            this.showLoading();
            this.selectArea2 = '';
            this.selectArea3 = '';
            this.area2 = [];
            this.area3 = [];
            this.input();
            this.isLoading1 = true;
            var res=await  this.$http.post('Static/GetAreaList', {id:0})
            if(res.Status){
                this.close();
                this.isLoading1 = false;
                this.area1 = res.Result;
                if (this.selectArea1 == '') {
                    this.selectArea1 = this.defaultValue[0];
                }
                this.upArea2();
            } 
        },
        // 市
        async upArea2() {
            this.showLoading();

            // this.selectArea2 = '';
            this.selectArea3 = '';
            this.area2 = [];
            this.area3 = [];
            this.input();
            this.isLoading2 = true; 
            var res=await  this.$http.post('Static/GetAreaList', {id: this.selectArea1})

            if(res.Status){
                this.close();
                this.isLoading2 = false;
                this.area2 = res.Result;
                if (this.selectArea2 == '') {
                    this.selectArea2 = this.defaultValue[1];
                } else {
                    this.selectArea2 = res.Result[0].AreaId;
                }
                this.upArea3();
            }

            
        },
        // 区
      async  upArea3() {
            this.showLoading();
            this.selectArea3 = '';
            this.area3 = [];
            this.input();
            this.isLoading3 = true;
            var res=await  this.$http.post('Static/GetAreaList', {id: this.selectArea2})
             if(res.Status)
             {
                this.close();
                this.isLoading3 = false;
                this.area3 = res.Result;
                this.isjudge = this.defaultValue[3];

                if (this.selectArea3 == '') {
                    this.selectArea3 = this.defaultValue[2];
                } else {
                    this.selectArea3 = this.area3[0].AreaId;
                }
             }
        },
        input() {

            let arr = [
                this.selectArea1,
                this.selectArea2,
                this.selectArea3,
                this.isjudge,
            ];


            console.warn(arr);



            this.$emit('input', arr);

        }
    },
    // 计算属性
    computed: {},
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {},
    // 在实例创建完成后被立即调用
    created() { },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() { },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
        this.init();
        this.$nextTick(() => { });
    },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() { },
    // keep-alive 组件激活时调用。
    activated() { },
    // keep-alive 组件停用时调用。
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。此
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {
        value() {
            this.$emit('change', this.value);
        }
    },
    // 组件列表
    components: {},
};